import { MultiSelect } from 'primereact/multiselect';

type DropdowsProps = {
  id?: string;
  label?: string;
  name?: string;
  className?: string;
  placeholder?: string;
  onChange?: any;
  options: any[];
  optionLabel: string;
  value?: any;
  disabled?: boolean;
  max?: number;
  itemTemplate?: any;
  selectedItemsLabel?: string;
};

export const MultiSelectComponent = (props: DropdowsProps) => {
  const {
    label,
    className,
    placeholder,
    onChange,
    options,
    optionLabel,
    value,
    id,
    itemTemplate,
    selectedItemsLabel,
    name,
  } = props;
  let classMultiSelect = `${className} w-full md:w-20rem text-center`;
  return (
    <div className="flex justify-center w-full flex-col">
      <p title={label} className="font-medium text-md sm:text-sm truncate">
        {label}
      </p>
      <MultiSelect
        id={id}
        value={value}
        name={name}
        onChange={onChange}
        options={options}
        optionLabel={optionLabel}
        placeholder={placeholder}
        selectedItemsLabel={selectedItemsLabel}
        maxSelectedLabels={0}
        className={classMultiSelect}
        itemTemplate={itemTemplate}
      />
    </div>
  );
};
